import { isApiError } from "@core/api/api-error";
import { ApiService } from "@core/api/api-service";
import { CreateFastTrackPtInput } from "@domain/register/register-fast-track/fast-track-register";
import { InvalidVeevaUser } from "@domain/register/register-vip/vip-user-data-error";

export class FastTrackRegisterService {
	constructor(private readonly authenticatedAxiosApiService: ApiService) {}

	async registerFastTrackUser(fastTrackPtInput: CreateFastTrackPtInput): Promise<void> {
		try {
			await this.authenticatedAxiosApiService.post("/pts/fast-track/register", fastTrackPtInput, {}, () => false);
		} catch (e) {
			if (isApiError(e) && e.status === 404) {
				throw new InvalidVeevaUser(e.message);
			}
			throw e;
		}
	}
}
